import React, { useState, useEffect, useRef } from 'react'

// Deps
import config from 'config'
import omit from 'lodash/omit'
import { Base64 } from 'js-base64';

// Controllers
import { setError } from 'controllers/navigator'

// Sections
import Breadcrumbs from 'views/admin/sections/breadcrumbs'

// Partials
import { InputForm, FormInput } from 'views/shared/partials/forms'
import Loader from 'views/shared/partials/loader'
import Image from 'views/shared/partials/image'
import Btn from 'views/shared/partials/btn'

// Services
import companyServices from 'services/company'
import userServices from 'services/user'

// Data
import erpTypes from 'data/erp-types'
// import themes from 'data/themes'

const CompanyInfo = (props) => {
	const [submitting, setSubmitting] = useState(false);
	const [companyInfo, setCompanyInfo] = useState(false);
	const [customEmailConfig, setCustomEmailConfig] = useState(false);

	const [customSMSConfigEnabled, setCustomSMSConfigEnabled] = useState(false);
	const [customSMSProviders, setCustomSMSProviders] = useState(false);
	const [selectedCustomSMSProvider, setSelectedCustomSMSProvider] = useState(false);
	const [customSMSProviderData, setCustomSMSProviderData] = useState(false);

	// Terms
	const [distanceTermsEnabled, setDistanceTermsEnabled] = useState(false);
	const [distanceTermsData, setDistanceTermsData] = useState(false);

	const [kvkkTermsEnabled, setKvkkTermsEnabled] = useState(false);
	const [kvkkTermsData, setKvkkTermsData] = useState(false);

	const [membershipTermsEnabled, setMembershipTermsEnabled] = useState(false);
	const [membershipTermsData, setMembershipTermsData] = useState(false);

	const [privacyTermsEnabled, setPrivacyTermsEnabled] = useState(false);
	const [privacyTermsData, setPrivacyTermsData] = useState(false);

	const [preInfoTermsEnabled, setPreInfoTermsEnabled] = useState(false);
	const [preInfoTermsData, setPreInfoTermsData] = useState(false);

	const [customAnalyticsCodeEnabled, setCustomAnalyticsCodeEnabled] = useState(false);

	const [urlShortenerEnabled, setUrlShortenerEnabled] = useState(false);
	const [urlShortenerProviders, setUrlShortenerProviders] = useState(false);
	const [selectedUrlShortenerProvider, setSelectedUrlShortenerProvider] = useState(false);
	const [urlShortenerProviderData, setUrlShortenerProviderData] = useState(false);

	const logoInput = useRef();

	const getCompanyInfo = () => {
		setCompanyInfo(false);
		companyServices.getCompany().then((companyInfo) => {
			let parsedEmailConfig = {};
			try {
				parsedEmailConfig = JSON.parse(companyInfo.email_config);
			}
			catch(e) {}

			parsedEmailConfig = parsedEmailConfig ? parsedEmailConfig : {};
			
			const analyticsCode = companyInfo.analytics_code && companyInfo.analytics_code.length > 0 ? Base64.decode(companyInfo.analytics_code) : false;

			setCompanyInfo({
				...companyInfo,
				erp_type_option: (companyInfo.erp_type === 'api' ? erpTypes[0] : erpTypes[1]),

				analytics_code: analyticsCode,
				
				email_config_name: parsedEmailConfig.name,
				email_config_email: parsedEmailConfig.address,
			});

			setCustomEmailConfig(parsedEmailConfig.name && parsedEmailConfig.name.length && parsedEmailConfig.address && parsedEmailConfig.address.length);

			setCustomSMSConfigEnabled(companyInfo.sms_config && companyInfo.sms_config.length && companyInfo.sms_config !== '{}');

			setUrlShortenerEnabled(companyInfo.shortener_config && companyInfo.shortener_config.length && companyInfo.shortener_config !== '{}');

			setCustomAnalyticsCodeEnabled(analyticsCode ? true : false);

			// Terms
			setDistanceTermsEnabled(companyInfo.terms_mesafeli ? true : false);
			setDistanceTermsData(companyInfo.terms_mesafeli ? companyInfo.terms_mesafeli : false);

			setKvkkTermsEnabled(companyInfo.terms_kvkk ? true : false);
			setKvkkTermsData(companyInfo.terms_kvkk ? companyInfo.terms_kvkk : false);

			setMembershipTermsEnabled(companyInfo.terms_uyelik ? true : false);
			setMembershipTermsData(companyInfo.terms_uyelik ? companyInfo.terms_uyelik : false);

			setPrivacyTermsEnabled(companyInfo.terms_gizlilik ? true : false);
			setPrivacyTermsData(companyInfo.terms_gizlilik ? companyInfo.terms_gizlilik : false);

			setPreInfoTermsEnabled(companyInfo.terms_on_bilgilendirme ? true : false);
			setPreInfoTermsData(companyInfo.terms_on_bilgilendirme ? companyInfo.terms_on_bilgilendirme : false);
		})
	}

	const submit = (formData) => {
		setSubmitting(true);

		let newFormData = omit(
			formData,
			[
				'email_config_name', 'email_config_email',
				'sms_config_account_number', 'sms_config_user_name', 'sms_config_password', 'sms_config_originator', 'sms_config_short_number', 'sms_config_operator',
			]);

		if(customEmailConfig && formData.email_config_name && formData.email_config_email) {
			newFormData.email_config = JSON.stringify({
				name: formData.email_config_name,
				address: formData.email_config_email, 
			})
		}
		else if(!customEmailConfig) {
			newFormData.email_config = '{}';
		}

		if(customSMSConfigEnabled && customSMSProviderData) {
			var newSMSconfig = {};

			for(const field of customSMSProviderData) {
				newSMSconfig[field.name] = (field.type === 'select' && field.value && field.value.value) ? field.value.value : field.value;
			}

			newFormData.sms_config = JSON.stringify(newSMSconfig);
		}
		else if(!customSMSConfigEnabled) {
			newFormData.sms_config = '{}';
			newFormData.sms_providers_id = 0;
		}

		if(urlShortenerEnabled && urlShortenerProviderData) {
			var newShortenerConfig = {};

			for(const field of urlShortenerProviderData) {
				newShortenerConfig[field.name] = (field.type === 'select' && field.value && field.value.value) ? field.value.value : field.value;
			}

			newFormData.shortener_config = JSON.stringify(newShortenerConfig);
		}
		else if(!urlShortenerEnabled) {
			newFormData.shortener_config = '{}';
			newFormData.shortener_providers_id = 0;
		}

		if(setCustomAnalyticsCodeEnabled && newFormData.analytics_code && newFormData.analytics_code.length) {
			newFormData.analytics_code = Base64.encode(newFormData.analytics_code);
		}
		else {
			newFormData.analytics_code = 0;
		}

		if(distanceTermsEnabled && distanceTermsData) {
			newFormData.terms_mesafeli = distanceTermsData;
		}
		else {
			newFormData.terms_mesafeli = 0;
		}
		
		if(kvkkTermsEnabled && kvkkTermsData) {
			newFormData.terms_kvkk = kvkkTermsData;
		}
		else {
			newFormData.terms_kvkk = 0;
		}
		
		if(membershipTermsEnabled && membershipTermsData) {
			newFormData.terms_uyelik = membershipTermsData;
		}
		else {
			newFormData.terms_uyelik = 0;
		}
		
		if(privacyTermsEnabled && privacyTermsData) {
			newFormData.terms_gizlilik = privacyTermsData;
		}
		else {
			newFormData.terms_gizlilik = 0;
		}
		
		if(preInfoTermsEnabled && preInfoTermsData) {
			newFormData.terms_on_bilgilendirme = preInfoTermsData;
		}
		else {
			newFormData.terms_on_bilgilendirme = 0;
		}
		
		companyServices.updateCompany(newFormData).then((payload) => {
			getCompanyInfo();
			userServices.me().catch(() => {
				setError();
			})
			logoInput.current.reset();
		}).catch((info) => {
			console.warn('Update Company Error', info);
		}).finally(() => {
			setSubmitting(false);
		})
	}

	const updateCustomSMSProviderData = (name, value) => {
		setCustomSMSProviderData(customSMSProviderData.map((field) => ({
			...field,
			value: name === field.name ? value : field.value,
		})))
	}

	const updateUrlShortenerProviderData = (name, value) => {
		setUrlShortenerProviderData(urlShortenerProviderData.map((field) => ({
			...field,
			value: name === field.name ? value : field.value,
		})))
	}

	useEffect(() => {
		getCompanyInfo();
	}, [])

	useEffect(() => {
		if(!customSMSProviders && customSMSConfigEnabled && companyInfo) {
			companyServices.listSMSProviders().then((payload) => {
				setCustomSMSProviders(payload);

				setSelectedCustomSMSProvider(payload.find(p => p.value.toString() === companyInfo.sms_providers_id.toString()));
			}).catch(() => {
			})
		}
	}, [customSMSProviders, customSMSConfigEnabled, companyInfo]);

	useEffect(() => {
		if(selectedCustomSMSProvider && companyInfo) {
			try {
				var data = JSON.parse(selectedCustomSMSProvider.data_template);
				const infoData = companyInfo.sms_config ? JSON.parse(companyInfo.sms_config) : false;

				if(infoData) {
					for(const key in infoData) {
						if(data[key] || data[key] === '') {
							data[key] = infoData[key];
						}
					}
				}

				let fields = [];

				let uxData = {}

				try {
					uxData = JSON.parse(selectedCustomSMSProvider.data_template_ux);
				}
				catch(e) {
				}
	
				for(const key in data) {
					let fieldUX = (uxData && uxData[key]) ? uxData[key] : {};
					fields.push({
						type: fieldUX.type ? fieldUX.type : 'text',
						value: data[key],
						label: fieldUX.title ? fieldUX.title : key,
						name: key,
						options: fieldUX.options ? fieldUX.options : undefined,
					})
				}
	
				setCustomSMSProviderData(fields);
			}
			catch(e) {}
		}
	}, [selectedCustomSMSProvider, companyInfo])

	useEffect(() => {
		if(!urlShortenerProviders && urlShortenerEnabled && companyInfo) {
			companyServices.listURLShortenerProviders().then((payload) => {
				setUrlShortenerProviders(payload);

				setSelectedUrlShortenerProvider(payload.find(p => p.value.toString() === companyInfo.shortener_providers_id.toString()));
			}).catch(() => {
			})
		}
	}, [urlShortenerProviders, urlShortenerEnabled, companyInfo]);

	useEffect(() => {
		if(selectedUrlShortenerProvider && companyInfo) {
			try {
				var data = JSON.parse(selectedUrlShortenerProvider.data_template);
				const infoData = companyInfo.shortener_config ? JSON.parse(companyInfo.shortener_config) : false;

				if(infoData) {
					for(const key in infoData) {
						if(data[key] || data[key] === '') {
							data[key] = infoData[key];
						}
					}
				}

				let fields = [];

				let uxData = {}

				try {
					uxData = JSON.parse(selectedUrlShortenerProvider.data_template_ux);
				}
				catch(e) {
				}
	
				for(const key in data) {
					let fieldUX = (uxData && uxData[key]) ? uxData[key] : {};
					fields.push({
						type: fieldUX.type ? fieldUX.type : 'text',
						value: data[key],
						label: fieldUX.title ? fieldUX.title : key,
						name: key,
						options: fieldUX.options ? fieldUX.options : undefined,
					})
				}
	
				setUrlShortenerProviderData(fields);
			}
			catch(e) {}
		}
	}, [selectedUrlShortenerProvider, companyInfo])

	return (
		<main className="page company-info">
			<Breadcrumbs />
			<InputForm className="portlet" onSubmit={submit}>
				<div className="portlet-header">
					<h1 className="portlet-title">Firma Bilgileri</h1>
				</div>
				<div className="portlet-section loader-container">
					<Loader loading={!companyInfo} />

					<div className="grid-container">
						<div className="row">
							<div className="col x6">
								<FormInput
									disabled={!companyInfo || submitting}
									type="text"
									label="Firma Adı"
									placeholder="Firma adı girin"
									name="company_name"
									autoComplete="organization"
									validation={{
										required: 'Firma adı girmelisiniz.'
									}}
									value={companyInfo ? companyInfo.name : undefined} />
							</div>
							<div className="col x6">
								<FormInput
									disabled={!companyInfo || submitting}
									type="email"
									label="E-Posta"
									placeholder="E-Posta girin"
									name="email"
									autoComplete="email"
									validation={{
										required: 'E-posta adresi girmelisiniz.',
										email: 'Geçerli bir e-posta girmelisiniz.',
									}}
									value={companyInfo ? companyInfo.email : undefined} />
							</div>
						</div>
						<div className="row">
							<div className="col x6">
								<FormInput
									type="phone"
									disabled={!companyInfo || submitting}
									mask="phone"
									label="Telefon"
									placeholder="Telefon girin"
									validation={{
										required: "Telefon girmelisiniz",
										phone: "Geçerli bir telefon numarası girmelisiniz",
									}}
									name="phone_number"
									autoComplete="tel"
									value={companyInfo ? ((companyInfo.phone_number.charAt(0) === '9' ? '+' : '') +companyInfo.phone_number) : undefined} />
							</div>
							<div className="col x6">
								<FormInput
									disabled={!companyInfo || submitting}
									type="text"
									label="Vergi dairesi"
									placeholder="Vergi dairesi girin"
									name="tax_office"
									autoComplete="tax-office"
									validation={{
										required: 'Vergi dairesi girmelisiniz.'
									}}
									value={companyInfo ? companyInfo.tax_office : undefined} />
							</div>
						</div>
						<div className="row">
							<div className="col x6">
								<FormInput
									disabled={!companyInfo || submitting}
									type="text"
									label="Vergi numarası"
									placeholder="Vergi numarası girin"
									name="tax_number"
									autoComplete="tax-number"
									mask="numeric"
									validation={{
										required: 'Vergi numarası girmelisiniz.',
										taxOrID: 'Geçerli bir vergi numarası girmelisiniz.',
									}}
									maxLength={12}
									value={companyInfo ? companyInfo.tax_number : undefined} />
							</div>
							<div className="col x6">
								<FormInput
									disabled={!companyInfo || submitting}
									type="text"
									label="Vergi ismi"
									placeholder="Vergi ismi girin"
									name="invoice_name"
									autoComplete="organization"
									validation={{
										required: 'Vergi ismi girmelisiniz.'
									}}
									value={companyInfo ? companyInfo.invoice_name : undefined} />
							</div>
						</div>
						<div className="row">
							<div className="col">
								<FormInput
									disabled={!companyInfo || submitting}
									type="textarea"
									label="Vergi adresi"
									placeholder="Vergi adresi girin"
									name="invoice_address"
									autoComplete="address"
									rows={3}
									validation={{
										required: 'Vergi adresi girmelisiniz.',
									}}
									value={companyInfo ? companyInfo.invoice_address : undefined} />
							</div>
						</div>
						<div className="row">
							<div className="col x6">
								<FormInput
									disabled={!companyInfo || submitting}
									type="select"
									label="ERP Türü"
									placeholder="ERP türü seçin"
									name="erp_type"
									options={erpTypes}
									validation={{
										required: 'ERP türü seçmelisiniz'
									}}
									defaultValue={companyInfo.erp_type_option ? companyInfo.erp_type_option : undefined} />
							</div>
							<div className="col x6">
								<FormInput
									disabled={!companyInfo || submitting}
									type="text"
									label="IBAN numarası"
									placeholder="IBAN numarası girin"
									name="iban"
									autoComplete="iban"
									mask="iban"
									validation={{
										required: 'IBAN numarası girmelisiniz.',
										iban: true,
									}}
									value={companyInfo ? companyInfo.iban : undefined} />

								<div className="form-note error">
									Ödemeleriniz bu hesaba aktarılacaktır, lütfen IBAN numaranızın doğruluğundan emin olunuz.
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<FormInput
									disabled={!companyInfo || submitting}
									type="textarea"
									label="Ödeme şartları"
									placeholder=""
									name="contract_text"
									rows={3}
									value={companyInfo ? companyInfo.contract_text : undefined} />

								<div className="form-note">Ödeme şartları, ödeme anında kullanıcının onayladığı sözleşmede görüntülenir.</div>
							</div>
						</div>
						{/* <div className="row apart">
							<div className="col x6">
								<FormInput
									disabled={!companyInfo || submitting}
									type="select"
									label="Terminal Ekranı Tema Seçimi"
									options={themes}
									defaultOption={themes[0]}
									value={(companyInfo && companyInfo.theme_id) ? themes.find(t => t.value === companyInfo.theme_id) : themes[0]}
									name="theme_id" />
							</div>
						</div> */}
						<div className="row apart">
							<div className="col x6">
								<FormInput
									disabled={!companyInfo || submitting}
									type="checkbox"
									checked={customEmailConfig}
									onChange={(val) => { setCustomEmailConfig(val ? true : false) }}
									value="1"
									label="E-Posta Gönderici Bilgilerini Özelleştir" />
							</div>
						</div>
						{customEmailConfig &&
							<>
								<div className="row">
									<div className="col x6 no-gap-top no-gap-bottom">
										<FormInput
											disabled={!companyInfo || submitting}
											type="text"
											label="Gönderici Adı"
											placeholder="İsim girin"
											name="email_config_name"
											autoComplete="organization"
											validation={{
												required: 'İsim bilgisi girmelisiniz.',
											}}
											value={companyInfo ? companyInfo.email_config_name : undefined} />
									</div>
									<div className="col x6 no-gap-top no-gap-bottom">
										<FormInput
											disabled={!companyInfo || submitting}
											type="email"
											label="Gönderici E-postası"
											placeholder="İsim girin"
											name="email_config_email"
											autoComplete="email"
											validation={{
												required: 'E-posta bilgisi girmelisiniz.',
												email: 'Geçerli bir e-posta adresi girmelisiniz.',
											}}
											value={companyInfo ? companyInfo.email_config_email : undefined} />
									</div>
								</div>
								<div className="row">
									<div className="col">
										<div className="form-note boxed">
											<p>Maillerinizin göndericisini değiştirdiğinizde spam klasörlerine düşmemesi için aşağıdaki ayarları yapmanız gerekmektedir.</p>
											<p>DNS yöneticisinizden aşağıdaki TXT kayıtlarını girmesini istemelisiniz;</p>
											<p>
												<i className="quote">mandrill._domainkey.alanadiniz.com</i> alt alan adı ile
											</p>
											<p>
												<i className="quote">v=DKIM1; k=rsa; p=MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCrLHiExVd55zd/IQ/J/mRwSRMAocV/hMB3jXwaHH36d9NaVynQFYV8NaWi69c1veUtRzGt7yAioXqLj7Z4TeEUoOLgrKsn8YnckGs9i3B3tVFB+Ch/4mPhXWiNfNdynHWBcPcbJ8kjEQ2U8y78dHZj1YeRXXVvWob2OaKynO8/lQIDAQAB;</i>
											</p>
											<p>alanadiniz.com alan adı ile de</p>
											<p>
												<i className="quote">v=spf1 a mx include:spf.mandrillapp.com -all</i>
											</p>
											<p>Bu iki kayıdı girdikten sonra maillerinizin göndercisini doğrulamış olacaksınız.</p>
										</div>
									</div>
								</div>
							</>
						}
						<div className="row">
							<div className="col x6">
								<FormInput
									disabled={!companyInfo || submitting}
									type="checkbox"
									checked={customSMSConfigEnabled}
									onChange={(val) => { setCustomSMSConfigEnabled(val ? true : false) }}
									value="1"
									label="SMS Entegrasyon Bilgilerini Özelleştir" />
							</div>
						</div>
						{customSMSConfigEnabled &&
							<>
								<div className="row">
									<div className="col x6 no-gap-top">
										<FormInput
											disabled={!companyInfo || submitting}
											type="select"
											label="SMS Servis Sağlayıcısı"
											placeholder="Bir Servis Sağlayıcısı Seçin"
											name="sms_providers_id"
											options={customSMSProviders ? customSMSProviders : null}
											value={selectedCustomSMSProvider}
											onChange={setSelectedCustomSMSProvider}
											validation={{
												required: 'Servis sağlayıcı seçmelisiniz'
											}} />
									</div>
								</div>
								{(customSMSProviderData && customSMSProviderData.length > 0) ?
									<div className="row">
										{customSMSProviderData.map((field, nth) => (
											<div className="col x6" key={field.name}>
												<FormInput
													name={`urlshortenerdata-${field.name}`}
													type={field.type}
													label={field.label}
													value={field.value}
													onChange={(val) => {
														updateCustomSMSProviderData(field.name, val);
													}}
													validation={{
														required: `${field.label} alanını doldurmalısınız.`
													}} />
											</div>
										))}
									</div>
									:
									<div className="row">
										<div className="col x6">
											Ayarları girmek için bir servis sağlayıcısı seçmelisiniz.
										</div>
									</div>
								}
							</>
						}
						{/*customSMSConfigEnabled &&
							<>
								<div className="row">
									<div className="col x6 no-gap-top">
										<FormInput
											disabled={!companyInfo || submitting}
											type="text"
											label="Hesap Numarası"
											placeholder="Hesap Numarası Girin"
											name="sms_config_account_number"
											autoComplete="off"
											validation={{
												required: 'Bir hesap numarası girmelisiniz.',
											}}
											value={companyInfo ? companyInfo.sms_config_account_number : undefined} />
									</div>
									<div className="col x6 no-gap-top">
										<FormInput
											disabled={!companyInfo || submitting}
											type="text"
											label="Kullanıcı Adı"
											placeholder="Kullanıcı Adı Girin"
											name="sms_config_user_name"
											autoComplete="off"
											validation={{
												required: 'Kullanıcı adı girmelisiniz.',
											}}
											value={companyInfo ? companyInfo.sms_config_user_name : undefined} />
									</div>
								</div>
								<div className="row">
									<div className="col x6">
										<FormInput
											disabled={!companyInfo || submitting}
											type="text"
											label="Şifre"
											placeholder="Şifre Girin"
											name="sms_config_password"
											autoComplete="off"
											validation={{
												required: 'Bir şifre girmelisiniz.',
											}}
											value={companyInfo ? companyInfo.sms_config_password : undefined} />
									</div>
									<div className="col x6">
										<FormInput
											disabled={!companyInfo || submitting}
											type="text"
											label="Gönderici"
											placeholder="Gönderici Girin"
											name="sms_config_originator"
											autoComplete="off"
											validation={{
												required: 'Bir gönderici girmelisiniz.',
											}}
											value={companyInfo ? companyInfo.sms_config_originator : undefined} />
									</div>
								</div>
								<div className="row">
									<div className="col x6 no-gap-bottom">
										<FormInput
											disabled={!companyInfo || submitting}
											type="text"
											label="Numara"
											placeholder="Numara Girin"
											name="sms_config_short_number"
											autoComplete="off"
											validation={{
												required: 'Bir numara girmelisiniz.',
											}}
											value={companyInfo ? companyInfo.sms_config_short_number : undefined} />
									</div>
									<div className="col x6 no-gap-bottom">
										<FormInput
											disabled={!companyInfo || submitting}
											type="text"
											label="Operatör"
											placeholder="Operatör Girin"
											name="sms_config_operator"
											autoComplete="off"
											validation={{
												required: 'Bir operatör girmelisiniz.',
											}}
											value={companyInfo ? companyInfo.sms_config_operator : undefined} />
									</div>
								</div>
								<div className="row">
									<div className="col">
										<div className="form-note boxed">
											<p>SMS gönderim entegrasyonu şu an için yalnızca dataport API'sini desteklemektedir.</p>
										</div>
									</div>
								</div>
							</>
						*/}
						<div className="row">
							<div className="col x6">
								<FormInput
									disabled={!companyInfo || submitting}
									checked={urlShortenerEnabled}
									type="checkbox"
									onChange={(val) => { setUrlShortenerEnabled(val ? true : false) }}
									value="1"
									label="URL Kısaltma Entegrasyon Bilgilerini Özelleştir" />
							</div>
						</div>
						{urlShortenerEnabled &&
							<>
								<div className="row">
									<div className="col x6 no-gap-top">
										<FormInput
											disabled={!companyInfo || submitting}
											type="select"
											label="URL Kısaltma Servis Sağlayıcısı"
											placeholder="Bir Servis Sağlayıcısı Seçin"
											name="shortener_providers_id"
											options={urlShortenerProviders ? urlShortenerProviders : null}
											value={selectedUrlShortenerProvider}
											onChange={setSelectedUrlShortenerProvider}
											validation={{
												required: 'Servis sağlayıcı seçmelisiniz'
											}} />
									</div>
								</div>
								{(urlShortenerProviderData && urlShortenerProviderData.length > 0) ?
									<div className="row">
										{urlShortenerProviderData.map((field, nth) => (
											<div className="col x6" key={field.name}>
												<FormInput
													name={`urlshortenerdata-${field.name}`}
													type={field.type}
													label={field.label}
													value={field.value}
													onChange={(val) => {
														updateUrlShortenerProviderData(field.name, val);
													}}
													validation={{
														required: `${field.label} alanını doldurmalısınız.`
													}} />
											</div>
										))}
									</div>
									:
									<div className="row">
										<div className="col x6">
											Ayarları girmek için bir servis sağlayıcısı seçmelisiniz.
										</div>
									</div>
								}
							</>
						}

						<div className="row">
							<div className="col x6">
								<FormInput
									disabled={!companyInfo || submitting}
									checked={customAnalyticsCodeEnabled}
									type="checkbox"
									onChange={(val) => { setCustomAnalyticsCodeEnabled(val ? true : false) }}
									value="1"
									label="Ödeme Ekranı için Özel Analytics Kodu Kullan" />
							</div>
						</div>

						{customAnalyticsCodeEnabled &&
							<>
								<div className="row">
									<div className="col">
										<FormInput
											disabled={!companyInfo || submitting}
											type="textarea"
											label="Analytics Kodu"
											placeholder="Bir analytics kodu girin"
											name="analytics_code"
											autoComplete="off"
											rows={3}
											validation={{
												required: 'Analytics kodu girmelisiniz.',
											}}
											value={companyInfo ? companyInfo.analytics_code : undefined} />
									</div>
								</div>
							</>
						}

						<hr />
						<div className="row">
							<div className="col x6">
								<FormInput
									disabled={!companyInfo || submitting}
									type="text"
									label="URL bilgisi"
									placeholder="URL bilgisi girin"
									name="company_valid_url"
									autoComplete="url"
									validation={{
										required: 'URL bilgisi girmelisiniz.',
										url: ['Geçerli bir URL girmelisiniz.', false]
									}}
									value={companyInfo ? companyInfo.company_valid_url : undefined} />

								{companyInfo &&
									<div className="form-note">
										<p>Sayfanın size ayrılmış url'i : merchantv2.odedim.com/company/{companyInfo.sub_url} olarak ayarlanmıştır.</p>
										<p>Bu sayfayı kendi web siteniz altında farklı bir adreste yayınlamak isterseniz, yukarıdaki URL alanına bu adresi yazmalısınız, ayrıca bu alan adının DNS yönetiminde CNAME kayıdı olarak da size ayrılmış URL'i yazmanız gerekmektedir.</p>
									</div>
								}
							</div>
							<div className="col x6">
								<FormInput
									disabled={!companyInfo || submitting}
									type="file"
									label="Logo görseli"
									placeholder=""
									ref={(ref) => { logoInput.current = ref}}
									validation={{
										required: 'Bir dosya girilmeli',
										fileSize: ['Dosya boyutu en fazla {maxSize} olabilir.', 1024],
										fileFormat: [true, ['image/jpeg', 'image/png', 'image/gif']],
									}}
									name="logo_url" />
									<div className="form-note">Logo dosyasını en az 150x150, en fazla 600x600 boyutlarında, kare png/jpeg/gif veya kare svg formatında yüklemenizi öneririz.</div>

									{(companyInfo && companyInfo.logo_url) &&
										<div className="section info-logopreview">
											<Image
												bg contain
												src={config.cdnUrl + 'company_logo/' + companyInfo.logo_url}
												className="logopreview-logo" />
												<p className="logopreview-note">* Logo görseli kare formatta gösterilecektir.</p>
										</div>
									}
							</div>
						</div>

						<hr />
						<div className="row">
							<div className="col no-gap-top no-gap-bottom">
								<FormInput
									disabled={!companyInfo || submitting}
									checked={distanceTermsEnabled}
									type="checkbox"
									onChange={(val) => { setDistanceTermsEnabled(val ? true : false) }}
									value="1"
									label="Mesafeli Satış Sözleşmesi Gir" />
							</div>
						</div>

						{distanceTermsEnabled &&
							<div className="row">
								<div className="col">
									<FormInput
										disabled={!companyInfo || submitting}
										type="wysiwyg"
										name="terms_mesafeli"
										onChange={setDistanceTermsData}
										value={distanceTermsData ? distanceTermsData : undefined}
										placeholder="Mesafeli Satış Sözleşmesi Gir"
										label="Mesafeli Satış Sözleşmesi" />
								</div>
							</div>
						}

						<div className="row">
							<div className="col no-gap-top no-gap-bottom">
								<FormInput
									disabled={!companyInfo || submitting}
									checked={kvkkTermsEnabled}
									type="checkbox"
									onChange={(val) => { setKvkkTermsEnabled(val ? true : false) }}
									value="1"
									label="KVKK Metni Gir" />
							</div>
						</div>

						{kvkkTermsEnabled &&
							<div className="row">
								<div className="col">
									<FormInput
										disabled={!companyInfo || submitting}
										type="wysiwyg"
										name="terms_kvkk"
										onChange={setKvkkTermsData}
										value={kvkkTermsData ? kvkkTermsData : undefined}
										placeholder="KVKK Metni Gir"
										label="KVKK Metni" />
								</div>
							</div>
						}

						<div className="row">
							<div className="col no-gap-top no-gap-bottom">
								<FormInput
									disabled={!companyInfo || submitting}
									checked={membershipTermsEnabled}
									type="checkbox"
									onChange={(val) => { setMembershipTermsEnabled(val ? true : false) }}
									value="1"
									label="Üyelik Sözleşmesi Gir" />
							</div>
						</div>

						{membershipTermsEnabled &&
							<div className="row">
								<div className="col">
									<FormInput
										disabled={!companyInfo || submitting}
										type="wysiwyg"
										name="terms_uyelik"
										onChange={setMembershipTermsData}
										value={membershipTermsData ? membershipTermsData : undefined}
										placeholder="Üyelik Sözleşmesi Gir"
										label="Üyelik Sözleşmesi" />
								</div>
							</div>
						}

						<div className="row">
							<div className="col no-gap-top no-gap-bottom">
								<FormInput
									disabled={!companyInfo || submitting}
									checked={privacyTermsEnabled}
									type="checkbox"
									onChange={(val) => { setPrivacyTermsEnabled(val ? true : false) }}
									value="1"
									label="Gizlilik Sözleşmesi Gir" />
							</div>
						</div>

						{privacyTermsEnabled &&
							<div className="row">
								<div className="col">
									<FormInput
										disabled={!companyInfo || submitting}
										type="wysiwyg"
										name="terms_gizlilik"
										onChange={setPrivacyTermsData}
										value={privacyTermsData ? privacyTermsData : undefined}
										placeholder="Gizlilik Sözleşmesi Gir"
										label="Gizlilik Sözleşmesi" />
								</div>
							</div>
						}
						
						<div className="row">
							<div className="col no-gap-top no-gap-bottom">
								<FormInput
									disabled={!companyInfo || submitting}
									checked={preInfoTermsEnabled}
									type="checkbox"
									onChange={(val) => { setPreInfoTermsEnabled(val ? true : false) }}
									value="1"
									label="Ön Bilgilendirme Metni Gir" />
							</div>
						</div>

						{preInfoTermsEnabled &&
							<div className="row">
								<div className="col">
									<FormInput
										disabled={!companyInfo || submitting}
										type="wysiwyg"
										name="terms_on_bilgilendirme"
										onChange={setPreInfoTermsData}
										value={preInfoTermsData ? preInfoTermsData : undefined}
										placeholder="Ön Bilgilendirme Metni Gir"
										label="Ön Bilgilendirme Metni" />
								</div>
							</div>
						}
						
					</div>
				</div>
				<div className="portlet-section bottom align-right border-top">
					<Btn
						type="submit"
						loading={submitting}
						disabled={submitting || !companyInfo}>
						Firma Bilgilerini Güncelle
					</Btn>
				</div>
			</InputForm>

		</main>
	)
}

export default CompanyInfo